/**
 * Formats a number as currency with commas and 2 decimal places
 * @param value - Number to format
 * @param currency - Currency symbol (default: $)
 * @returns Formatted string (e.g., "$1,234.56")
 */
export const formatCurrency = (value: number, currency: string = '$'): string => {
  return `${currency}${value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
};

/**
 * Formats a number with commas for thousands
 * @param value - Number to format
 * @returns Formatted string (e.g., "1,234")
 */
export const formatNumber = (value: number): string => {
  return value.toLocaleString('en-US');
};

/**
 * Formats a number as a percentage
 * @param value - Number to format (e.g., 0.156 for 15.6%)
 * @param decimals - Number of decimal places (default: 1)
 * @returns Formatted string (e.g., "15.6%")
 */
export const formatPercent = (value: number, decimals: number = 1): string => {
  return `${(value * 100).toFixed(decimals)}%`;
};
